module.exports = __webpack_public_path__ + "static/media/spotify.0267a6ec.png";